import { useCallback, useEffect, useState } from "react";
import useRazorpay from "react-razorpay";
import { verify_payment } from "../../actions/payment/payment";
import { useNavigate } from "react-router-dom";
import SuccessEvent from "../explore/SuccessEvent";
import { razor_payment_key } from "../../constants/payment";
import { redirectUrl } from "../../constants/Api";

export default function Payment(props) {
  const [Razorpay, isLoaded] = useRazorpay();
  const { price, paymentObj, hotelId, loadingOn, loadingOff, appUserId, updateTicketCount, mobileNo } =
    props;
  const [successPop, setSuccessPop] = useState("");
  const navigate = useNavigate();

  const handleVerify = async (
    razorpay_payment_id,
    razorpay_order_id,
    razorpay_signature
  ) => {
    try {
      loadingOn();
      const res = await verify_payment(
        razorpay_payment_id,
        razorpay_order_id,
        razorpay_signature,
        paymentObj?.bookingId,
        hotelId,
        price,
        appUserId
      );
      if (res?.data?.success) {
        loadingOff();
        setSuccessPop("success");
        setTimeout(() => {
          setSuccessPop("");
          window.location.href = `${redirectUrl}/#/tickets`;
        }, 3000);
        updateTicketCount()
      } else {
        loadingOff();
        setSuccessPop("fail");
        setTimeout(() => {
          setSuccessPop("");
          // window.location.href = `${redirectUrl}/#/tickets`
        }, 3000);
      }
    } catch (e) {
      loadingOff();
      setSuccessPop("fail");
      setTimeout(() => {
        setSuccessPop("");
        // window.location.href = `${redirectUrl}/#/tickets`
      }, 3000);
    }
  };

  const handlePayment = useCallback(async () => {
    const options = {
      key: razor_payment_key,
      amount: price * 100,
      currency: "INR",
      name: "Edaya Guest Web",
      description: "Guest engagement App",
      image: "https://release.edayaapp.com/images/blue-1.png",
      order_id: paymentObj?.data,
      handler: (res) => {
        console.log(res);
        handleVerify(
          res?.razorpay_payment_id,
          res?.razorpay_order_id,
          res?.razorpay_signature
        );
      },
   

      prefill: { 
        contact: mobileNo,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3d38af",
      },
      modal: {
        ondismiss: () => {
           alert("Payment process was interrupted. Please try again.");
          // Optionally, refresh or redirect the page
          window.location.reload();
        },
      },
    };
    console.log("object")
    const rzpay = new Razorpay(options);
    rzpay.on('payment.failed', (response) => {
      console.error(response?.error?.description);
     alert(response?.error?.description);
      console.log("object")
      window.location.reload() 
    });


    

    rzpay.open();
  }, [Razorpay]);

  useEffect(() => {
    console.log(price);
    if (isLoaded) {
      handlePayment();
    }
  }, [isLoaded]);

  return (
    <>
      {successPop && (
        <SuccessEvent
          status={successPop}
          navigate={() => {
            if (successPop !== "fail") {
              window.location.assign(`${redirectUrl}/#/tickets`);
            }
          }}
        />
      )}
    </>
  );
}
